import {FC} from 'react'

import AlternativeRegister from '@progyny/pages/Register/AlternativeRegister'

const WWT: FC = () => (
  <AlternativeRegister
    firstField={{
      name: 'employeeId',
      labelKey: 'register_employee_id',
      placeholder: '1234567',
      validate: (value) => /^[0-9]{6,}$/.test(value),
      invalidMessageKey: 'register_invalid_employee_id',
    }}
    secondField={{
      name: 'employmentStart',
      labelKey: 'register_wwt_employment_start_date',
      placeholder: 'YYYY-MM-DD',
      validate: (value) => /^[0-9]{4}-[0-9]{2}-[0-9]{2}$/.test(value),
      invalidMessageKey: 'register_wwt_please_provide_date_in_yyyymmdd',
    }}
    submitButtonLabelKey='register_send_confirmation_email'
  />
)

export default WWT
